import { styled } from "@mui/material/styles";
import { Crown } from "@piiqtechnologies/svg-icons";
import { PeekBadge, PeekList, PeekMiniDrawer, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { Policy, usePolicyContext } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import HelpDesk from "./HelpDesk";
import Logout from "./Logout";
import { NavigationListItemsConfig } from "./NavigationConfig";
import NavigationListItem from "./NavigationListItem";
import { PeekLogo } from "./PeekLogo";
import Settings from "./Settings";
const NavigationList = styled(PeekList)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
}));
const SideBarHeader = ({ children }) => (React.createElement(PeekStack, { direction: "row", justifyContent: "flex-start" },
    React.createElement(PeekTypography, null, children)));
const NavigationListItemAccess = ({ action, children }) => {
    if (!action) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Policy, { action: action, mode: "hide" }, children));
};
export const SideNavBar = () => {
    const intl = useIntl();
    const { isAdmin } = useAuthContext();
    const [expanded, setExpanded] = useState(false);
    const displayListItemBadge = ({ action }) => {
        if (!usePolicyContext(action))
            return false;
        return true;
    };
    return (React.createElement(PeekMiniDrawer, { variant: "permanent", open: expanded, miniDrawerWidth: 80, drawerWidth: 258, bgColor: "white" },
        React.createElement(PeekStack, { justifyContent: "space-between", height: "100%", onMouseOver: () => setExpanded(true), onMouseLeave: () => setExpanded(false), py: 5.1, spacing: 4 },
            React.createElement(PeekStack, { spacing: 1.5 },
                React.createElement(PeekStack, { px: 3, pb: 2 },
                    React.createElement(SideBarHeader, null,
                        React.createElement(PeekStack, { gap: 1 },
                            React.createElement(PeekLogo, { expanded: expanded })))),
                React.createElement(NavigationList, { key: "top-nav-items", disablePadding: true, sx: { gap: { md: 2, lg: 3 } } }, NavigationListItemsConfig(isAdmin).map(({ label, subLabel, path, icon: Icon, iconSize, hideModePolicyAction, premiumModePolicyAction, color, }) => (React.createElement(NavigationListItemAccess, { key: path, action: hideModePolicyAction },
                    React.createElement(NavLink, { to: path, style: { textDecoration: "none" } }, ({ isActive }) => (React.createElement(NavigationListItem, { Icon: () => (React.createElement(PeekBadge, { color: "secondary", invisible: !!premiumModePolicyAction
                                ? displayListItemBadge({ action: premiumModePolicyAction })
                                : true, badgeContent: React.createElement(Crown, { width: "10px", height: "10px" }), sx: { "& .MuiBadge-badge": { minWidth: 15, height: 15, p: 0, zIndex: -1 } } },
                            React.createElement(Icon, { width: `${iconSize || 20}px`, height: `${iconSize || 20}px` }))), label: intl.formatMessage(label), subLabel: subLabel && intl.formatMessage(subLabel), expanded: expanded, active: isActive, color: color })))))))),
            React.createElement(PeekStack, { spacing: { md: 2, lg: 3 } },
                !isAdmin && (React.createElement(NavigationList, { key: "bottom-nav-items-helpdesk", disablePadding: true },
                    React.createElement(HelpDesk, { expanded: expanded }))),
                React.createElement(NavigationList, { key: "bottom-nav-items-settings", disablePadding: true },
                    React.createElement(Settings, { expanded: expanded })),
                React.createElement(NavigationList, { key: "bottom-nav-items", disablePadding: true },
                    React.createElement(Logout, { expanded: expanded }))))));
};
export default SideNavBar;
